import type { FC } from 'react';
import { Toaster as SonnerToaster } from 'sonner';
import { Icon } from '../assets/icons';
import { Loader } from './loader';

export const Toast: FC = () => {
  return (
    <SonnerToaster
      duration={3000}
      position={'bottom-right'}
      toastOptions={{
        className: '!rounded-none drop-shadow-lg',
        classNames: {
          title: 'text-[14px] !font-normal',
        },
      }}
      icons={{
        success: (
          <Icon
            name="success-circle"
            className="text-polar-green-6 dark:text-polar-green-7"
            size={14}
          />
        ),
        error: (
          <Icon
            name="error-circle"
            className="text-dust-red-6 dark:text-dust-red-5"
            size={14}
          />
        ),
        info: <Icon name="info-circle" className="text-[#1890FF]" size={14} />,
        warning: (
          <Icon name="warning-circle" className="text-[#FFA940]" size={14} />
        ),
        loading: <Loader size={14} strokeWidth={4} />,
      }}
    />
  );
};
